import { IconChevronRight } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { NSCard } from 'bricks';
import './ConstructionEndVsSaleDate.scss';

export interface IConstructionEndVsSaleDateProps {
    constructionEnd: string;
    lastSale: string;
}

const ConstructionEndVsSaleDate = ({ constructionEnd, lastSale }: IConstructionEndVsSaleDateProps) => {
    return (
        <NSCard className="ConstructionEndVsSaleDate my-0 shadow-none text-dark">
            <div className="d-flex align-items-center px-2 font-12 my-1">
                <div>
                    <div className="font-weight-bold">Construction ends</div>
                    <div className="">{constructionEnd}</div>
                </div>
                <NSIcon
                    className="icon mx-4"
                    icon={IconChevronRight}
                    size="sm"
                />
                <div>
                    <div className="font-weight-bold">Last sale closes</div>
                    <div>{lastSale}</div>
                </div>
            </div>
        </NSCard>
    );
};

export default ConstructionEndVsSaleDate;
